import template from './xps-product-finder-list.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('xps-product-finder-list', {
    template,

    inject: [
        'repositoryFactory'
    ],

    mixins: [
        Mixin.getByName('listing')
    ],

    data() {
        return {
            productFinders: null,
            isLoading: true,
            sortBy: 'name',
            sortDirection: 'ASC',
            total: 0,
            searchTerm: ''
        };
    },

    metaInfo() {
        return {
            title: this.$tc('xps-product-finder.list.title')
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('xps_product_finder');
        },

        columns() {
            return [
                {
                    property: 'name',
                    dataIndex: 'name',
                    label: this.$tc('xps-product-finder.list.columnName'),
                    routerLink: 'xps.product.finder.detail',
                    inlineEdit: 'string',
                    allowResize: true,
                    primary: true
                },
                {
                    property: 'active',
                    dataIndex: 'active',
                    label: this.$tc('xps-product-finder.list.columnActive'),
                    inlineEdit: 'boolean',
                    allowResize: true
                },
                {
                    property: 'position',
                    dataIndex: 'position',
                    label: this.$tc('xps-product-finder.list.columnPosition'),
                    inlineEdit: 'number',
                    allowResize: true
                }
            ];
        }
    },

    created() {
        this.getList();
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.setTerm(this.searchTerm);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));
            criteria.addAssociation('steps');

            this.repository.search(criteria, Shopware.Context.api).then((result) => {
                this.productFinders = result;
                this.total = result.total;
                this.isLoading = false;
            });
        },

        onEdit(productFinder) {
            if (productFinder?.id) {
                this.$router.push({
                    name: 'xps.product.finder.detail',
                    params: { id: productFinder.id }
                });
            }
        },

        onInlineEditSave(promise, productFinder) {
            promise.then(() => {
                this.getList();
            }).catch(() => {
                this.getList();
            });
        },

        onChangeLanguage(languageId) {
            Shopware.State.commit('context/setApiLanguageId', languageId);
            this.getList();
        }
    }
});